<script lang="ts" module>
  export interface ProductInfoStockProps {
    stock: number;
  }
</script>

<script lang="ts">
  import { Check, Warning, X } from 'phosphor-svelte';
  import { css } from '@agapi/ui/panda/css';
  import { hstack, icon } from '@agapi/ui/panda/patterns';

  import * as m from '$lib/parachute/messages';

  const { stock }: ProductInfoStockProps = $props();
  const getStockStatus = (stock: number) => {
    if (stock <= 0) return 'out';
    if (stock <= 3) return 'limited';
    return 'in';
  };

  const status = $derived(getStockStatus(stock));
</script>

<div class={hstack({ gap: '2', alignItems: 'center', my: '-2' })}>
  {#if status === 'out'}
    <div class={css({ backgroundColor: 'feedback.error.background', borderRadius: 'full', p: '2' })}>
      <X
        size="11"
        class={icon({
          color: 'feedback.error.foreground'
        })}
      />
    </div>
    <span class={css({ color: 'feedback.error.foreground', fontSize: 'sm' })}>
      {m.outOfStock()}
    </span>
  {:else if status === 'limited'}
    <div class={css({ backgroundColor: 'feedback.alert.background', boxShadow: 'rgba(0, 0, 0, 0.15) 0px 1px 3px 0px', borderRadius: 'full', p: '1' })}>
      <Warning
        size="11"
        class={icon({
          color: 'feedback.alert.foreground'
        })}
      />
    </div>
    <span class={css({ color: 'feedback.alert.foreground', fontSize: 'sm' })}>
      {m.limitedStock()}
    </span>
  {:else}
    <div class={css({ backgroundColor: 'feedback.success.background', boxShadow: 'rgba(0, 0, 0, 0.15) 0px 1px 3px 0px', borderRadius: 'full', p: '1' })}>
      <Check
      size="11"
        class={icon({
          color: 'feedback.success.foreground'
        })}
      />
    </div>
    <span class={css({ color: 'feedback.success.foreground', fontSize: 'sm' })}>
      {m.inStock()}
    </span>
  {/if}
</div>
